import axios from 'axios'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 基础URL
  timeout: 5000 // 请求超时时间
})

// 标记是否正在刷新token，防止重复跳转
let isRefreshing = false

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送前添加token
    if (getToken()) {
      config.headers['Authorization'] = `Bearer ${getToken()}`
    }
    return config
  },
  error => {
    // 请求错误处理
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 正常响应处理
    return response.data
  },
  error => {
    console.error('响应错误:', error)
    
    // 处理401 Unauthorized错误（token过期或无效）
    if (error.response && error.response.status === 401) {
      // 防止重复处理
      if (!isRefreshing) {
        isRefreshing = true
        
        // 清除过期的token
        removeToken()
        
        // 显示错误信息
        Message.error('登录已过期，请重新登录')
        
        // 记录当前页面地址，登录后可跳转回来
        const currentPath = router.currentRoute.fullPath
        
        // 跳转到登录页
        router.push({
          path: '/login',
          query: { redirect: currentPath } // 携带当前路径作为跳转参数
        }).then(() => {
          // 重置标记
          isRefreshing = false
        })
      }
      
      // 返回一个pending状态的Promise，避免控制台报错
      return new Promise(() => {})
    }
    
    // 处理其他错误状态码
    if (error.response) {
      switch (error.response.status) {
        case 403:
          Message.error('没有权限访问该资源')
          break
        case 404:
          Message.error('请求的资源不存在')
          break
        case 500:
          Message.error('服务器内部错误')
          break
        default: {
          const data = error.response.data
          const errorMsg = (data && data.message) || error.message || '未知错误'
          Message.error('请求失败: ' + errorMsg)
        }
      }
    } else if (error.message && error.message.indexOf('timeout') !== -1) {
      Message.error('请求超时，请稍后重试')
    } else {
      Message.error('网络连接错误，请检查网络')
    }

    return Promise.reject(error)
  }
)

export default service
